import confetti from 'canvas-confetti';

const defaults = {
  zIndex: 2000,
  disableForReducedMotion: true,
};

const FALLBACK_ORIGIN = { x: 0.5, y: 0.65 };

type Origin = { x: number; y: number };

let lastButtonOrigin: Origin | null = null;

function clamp(value: number) {
  return Math.min(0.96, Math.max(0.04, value));
}

function originFromElement(el: Element): Origin | null {
  const rect = el.getBoundingClientRect();
  if (rect.width === 0 && rect.height === 0) return null;
  return {
    x: clamp((rect.left + rect.width / 2) / window.innerWidth),
    y: clamp((rect.top + rect.height / 2) / window.innerHeight),
  };
}

/** Remember the clicked control so a later success still bursts from that button. */
function rememberButtonClick(event: MouseEvent) {
  const target = event.target;
  if (!(target instanceof Element)) return;
  const button = target.closest('button, [role="button"]');
  if (!button) return;
  const origin = originFromElement(button);
  if (origin) lastButtonOrigin = origin;
}

if (typeof document !== 'undefined') {
  const flag = '__successConfettiClickBound';
  const scopedWindow = window as Window & { [flag]?: boolean };
  if (!scopedWindow[flag]) {
    scopedWindow[flag] = true;
    document.addEventListener('click', rememberButtonClick, true);
  }
}

/** Short cannon from the button that was just clicked. */
export function fireSuccessConfetti(source?: Element | null) {
  if (typeof window === 'undefined') return;

  const origin =
    (source && originFromElement(source)) || lastButtonOrigin || FALLBACK_ORIGIN;

  confetti({
    ...defaults,
    particleCount: 140,
    spread: 80,
    startVelocity: 42,
    origin,
  });
}
